import { Link } from 'react-router-dom';
import useBlur from '../hooks/useBlur';
import '../styles/Header.css';

function Header() {
    useBlur('header');

    return (
        <header>
            <div className='top-wrapper'>
                <Link to='/'>
                    <span className='top-title'>카라쿤의 퍼즐 월드</span>
                </Link>
            </div>
        </header>
    );
}

export default Header;